import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Col, FormGroup, Label, Button } from 'reactstrap';
import { BASE_URL, API, ESTADOS_OPORTUNIDAD, OPORTUNIDADES_STATE_SECTION_MAP } from 'CONST';
import { get, patch } from 'helpers/requests';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AvanzarOportunidadConfirmationModal from './AvanzarOportunidadConfirmationModal';
import CheckModal from '../shared/CheckModal';
import WarningModal from '../UI/WarningModal';

const AsignarSuscriptorSection = ({
  fullData,
  setFullData,
  setInitialSection,
  id,
  estadosOportunidad,
}) => {
  const [suscriptorOptions, setSuscriptorOptions] = useState([]);
  const [sectionData, setSectionData] = useState({
    suscriptor_id: null,
  });
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [editableSection, setEditableSection] = useState(false);
  const [defaultValue, setDefaultValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const editableStates = [ESTADOS_OPORTUNIDAD.creado];

  useEffect(() => {
    get(`${BASE_URL}${API.suscriptores}`).then((response) => {
      setSuscriptorOptions(
        response.results.map((e) => ({
          value: e.id,
          label: `${e.rut} - ${e.user.first_name} ${e.user.last_name}`,
        })),
      );
    });
  }, []);

  useEffect(() => {
    if (fullData && fullData.suscriptor_id) {
      setSectionData({ suscriptor_id: fullData.suscriptor_id });
    }
    if (fullData && fullData.estado && editableStates.includes(fullData.estado.nemotecnico)) {
      setEditableSection(true);
    }
  }, [fullData]);

  useEffect(() => {
    if (fullData.suscriptor_id && suscriptorOptions) {
      setDefaultValue(suscriptorOptions.find((e) => e.value === fullData.suscriptor_id));
    }
  }, [fullData, suscriptorOptions]);

  const asignarSuscriptor = () => {
    setLoading(true);
    const body = {
      ...sectionData,
      estado_id: estadosOportunidad.find(
        (e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.suscriptorAsignado,
      ).id,
    };
    patch(`${BASE_URL}${API.oportunidadesLinea}${id}/`, body)
      .then((response) => {
        setFullData(response);
        setInitialSection(OPORTUNIDADES_STATE_SECTION_MAP[response.estado.nemotecnico]);
        setEditableSection(false);
        setShowUpdateModal(true);
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setConfirmationModal(false);
        setLoading(false);
      });
  };

  return (
    <div>
      <FormGroup row>
        <Col sm={2}>
          <Label>
            Suscriptor
            <span className="required text-danger">*</span>
          </Label>
        </Col>
        <Col sm={5}>
          <Select
            options={suscriptorOptions}
            value={defaultValue}
            onChange={(event) => {
              setSectionData({ suscriptor_id: event.value });
              setDefaultValue(event);
            }}
            isDisabled={!editableSection}
            placeholder="Selecciona un suscriptor"
          />
        </Col>
      </FormGroup>
      {editableSection && (
        <div className="button-container d-flex justify-content-end">
          <Button
            className="btn btn-secondary blue"
            onClick={() => setConfirmationModal(true)}
            disabled={defaultValue === null || confirmationModal}
          >
            {loading ? <FontAwesomeIcon spin={loading} icon={faSpinner} /> : 'Asignar Suscriptor'}
          </Button>
        </div>
      )}
      <AvanzarOportunidadConfirmationModal
        openModal={confirmationModal}
        setOpenModal={setConfirmationModal}
        avanzarOportunidad={asignarSuscriptor}
        loading={loading}
      />
      <CheckModal
        isOpen={showUpdateModal}
        toggle={() => setShowUpdateModal(false)}
        handleOk={() => setShowUpdateModal(false)}
        okBtnText="OK"
        confirmMsg="Suscriptor asignado satisfactoriamente."
      />
      <WarningModal
        isOpen={showErrorModal}
        toggle={() => setShowErrorModal(false)}
        handleClearError={() => setShowErrorModal(false)}
        errorMsg="Ha ocurrido un error al asignar al suscriptor."
        loading={false}
        onlyCancelButton
      />
    </div>
  );
};

AsignarSuscriptorSection.propTypes = {
  id: PropTypes.string,
  fullData: PropTypes.shape({
    actualizacion_ts: PropTypes.string,
    afianzado: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      rut: PropTypes.string,
    }),
    afianzado_id: PropTypes.number,
    creacion_ts: PropTypes.string,
    estado: PropTypes.shape({
      descripcion: PropTypes.string,
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
    }),
    id: PropTypes.number,
    monto: PropTypes.number,
    responsable_id: PropTypes.number,
    suscriptor_id: PropTypes.number,
  }),
  setFullData: PropTypes.func.isRequired,
  setInitialSection: PropTypes.func.isRequired,
  estadosOportunidad: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
      descripcion: PropTypes.string,
    }),
  ),
};

AsignarSuscriptorSection.defaultProps = {
  fullData: null,
  id: null,
  estadosOportunidad: [],
};

export default AsignarSuscriptorSection;
